import {Component, OnInit, signal, WritableSignal} from '@angular/core';
import {MenuItem, PrimeNGConfig} from 'primeng/api';
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    constructor(private primengConfig: PrimeNGConfig, private router: Router) {
    }
    items: MenuItem[] = [];
    position: string = 'left';
    showCart: WritableSignal<boolean> = signal(false);
    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
        ).subscribe((event) => {
            console.log(event);
            if (event instanceof NavigationEnd) {
                const url = event.url.split('?')[0];
                const segments = url.split('/');
                const basePath = `/${segments[1]}/${segments[2]}`;
                this.showCart.set(basePath.endsWith('/users/tramites'));
            }
        });
        this.primengConfig.setTranslation({
            firstDayOfWeek: 1,
            dayNames: ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
            dayNamesShort: ["dom","lun","mar","mié","jue","vie","sáb"],
            dayNamesMin: ["D","L","M","X","J","V","S"],
            monthNames: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
            monthNamesShort: ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],
            today: 'Hoy',
            clear: 'Limpiar',
            dateFormat: 'dd/mm/yy',
            weekHeader: 'Sm'
          });
    }
}

